import React from "react";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";

import { CREATE_DRIVER, CREATE_USER, REFRESH } from "Constant";

import { store } from "../../redux/store";
import { toggleRefresh } from "../../redux/searchLink";

import OpenModalBtn from "Components/ModalApp/OpenModalBtn";

const LeftToolBar = () => {
  const { t } = useTranslation();
  const onRefresh = () => {
    store.dispatch(toggleRefresh());
  };
  return (
    <div className="flex flex-wrap gap-2">
      <OpenModalBtn type="createDriver">
        <Button
          label={t(CREATE_DRIVER)}
          icon="pi pi-plus"
          severity="success"
          raised
        />
      </OpenModalBtn>

      <Button
        label={t(REFRESH)}
        icon="pi pi-sync"
        severity="secondary"
        raised
        onClick={() => onRefresh()}
      />
    </div>
  );
};

export default LeftToolBar;
